import React from 'react';
import { ModuleName } from '@web/core/navigation/module-name';
import { DmsDetail } from './components/dms-detail';
import { DmsList } from './components/dms-list';
import NoMatch from '@web/views/no-match';

export type DmsRoute = { path?: string; index?: boolean; element: React.ReactNode; moduleName?: ModuleName };

export const dmsRoutes: DmsRoute[] = [
    { index: true, element: <DmsList />, moduleName: ModuleName.RepairOrders },
    { path: ':repairOrder', element: <DmsDetail />, moduleName: ModuleName.RepairOrders },
    { path: '*', element: <NoMatch /> },
];
